export default __webpack_public_path__ + "static/media/TicTacToe.bbb3ab14.jpg";